import { Typography, Checkbox, FormControl, FormLabel, Stack, TextField } from '@mui/material';
const matchesSearch = (category, categorySearch) => {
  const query = categorySearch.trim().toLocaleLowerCase();
  return (
    !query ||
    category.displayName.toLocaleLowerCase().includes(query) ||
    category.systemName.toLocaleLowerCase().includes(query)
  );
};
const CategoriesTab = ({ categories, categorySearch, setCategorySearch, placeForm, setPlaceForm }) => (
  <Stack
    sx={{
      width: "100%",
      display: 'grid',
      gap: '15px',
      overflow: 'hidden',
    }}
  >
    <Stack
      sx={{
        justifyContent: 'space-between',
        gap: '18px',
      }}
    >
      <Stack
        direction="row"
        sx={{
          gap: '5px',
          justifyContent: 'space-between',
          alignItems: 'end',
        }}
      >
        <TextField
          type="search"
          autoFocus
          placeholder="חיפוש לפי שם תצוגה או שם מערכת"
          value={categorySearch}
          onChange={(event) => setCategorySearch(event.target.value)}
        />

        <Typography variant="body2">{placeForm.categories.length} קטגוריות נבחרו</Typography>
      </Stack>
    </Stack>
    <FormControl
      sx={{
        gridColumn: '1 / -1',
        minWidth: '0',
        margin: '0',
        padding: '14px',
        border: '1px solid var(--line)',
        borderRadius: '12px',
        '& legend': {
          padding: '0 6px',
          fontWeight: '700',
        },
      }}
    >
      <Stack
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(190px, 1fr))',
          gap: '8px',
          maxHeight: '260px',
          overflow: 'auto',
        }}
      >
        {categories
          .filter((category) => matchesSearch(category, categorySearch))
          .map((category) => {
            const selected = placeForm.categories.includes(category.systemName);
            return (
              <Stack
                key={category._id || category.systemName}
                sx={{
                  display: 'grid',
                  gridTemplateColumns: 'auto 1fr',
                  alignItems: 'center',
                  gap: '8px',
                  padding: '6px 10px',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  borderRadius: 2,
                  borderWidth: 1,
                  borderStyle: 'solid',
                  borderColor: selected ? '#d3bdf4' : 'divider',
                  backgroundColor: selected ? '#f4e4fc' : 'background.paper',
                }}
              >
                <Checkbox
                  checked={selected}
                  onChange={(event) =>
                    setPlaceForm((current) => ({
                      ...current,
                      categories: event.target.checked
                        ? [...new Set([...current.categories, category.systemName])]
                        : current.categories.filter((name) => name !== category.systemName),
                    }))
                  }
                />
                <Stack>
                  <Typography>{category.displayName}</Typography>
                  <Typography sx={{ fontSize: 12, color: 'text.secondary' }}>
                    {category.systemName}
                  </Typography>
                </Stack>
              </Stack>
            );
          })}
      </Stack>
      {!categories.length && (
        <Typography>לא הוגדרו קטגוריות. יש להוסיף אותן בדף הקטגוריות.</Typography>
      )}
      {Boolean(categories.length) &&
        !categories.some((category) => matchesSearch(category, categorySearch)) && (
          <Typography>לא נמצאו קטגוריות שמתאימות לחיפוש.</Typography>
        )}
    </FormControl>
  </Stack>
);
export default CategoriesTab;
